import { formatMeasurement, measurementUnit, parseMeasurementUnit, type MeasurementQuantity } from '../../lib/measurement'
import type { MeasurementSystem } from '../../lib/measurementSystem'

/** Only show measurements supplied by the engine, never an invented threshold. */
export default function AlertMeasurement({ alert, system }: { alert: any; system: MeasurementSystem }) {
  const source = alert.measurement ?? alert.details
  const observed = source?.observed ?? source?.current
  const limit = source?.limit ?? source?.maximum
  const isNumber = (value: unknown): value is number => typeof value === 'number' && Number.isFinite(value)
  if (!isNumber(observed) && !isNumber(limit)) return <p className="mt-2 opacity-70">Valeur et limite non fournies par le moteur.</p>
  const delta = isNumber(observed) && isNumber(limit) ? observed - limit : null
  const format = (value: unknown) => {
    if (!isNumber(value)) return 'Non renseignée'
    try {
      const from = parseMeasurementUnit(source.unit)
      const quantity: MeasurementQuantity | undefined = ['kg', 'g', 't', 'lb'].includes(from) ? 'mass'
        : ['mm', 'cm', 'm', 'in', 'ft'].includes(from) ? 'vehicleLength'
          : ['kg/m2', 'lb/ft2'].includes(from) ? 'surfaceLoad' : undefined
      if (quantity) return formatMeasurement(value, from, measurementUnit(system, quantity))
    } catch { /* Unknown engine units remain explicit, without conversion. */ }
    return `${value.toLocaleString('fr-FR', { maximumFractionDigits: 2 })}${source.unit ? ` ${source.unit}` : ' (unité non fournie)'}`
  }
  return <dl className="mt-2 grid grid-cols-2 gap-x-3 gap-y-1 text-[11px]">
    <dt>Valeur observée</dt><dd>{format(observed)}</dd>
    <dt>Limite</dt><dd>{format(limit)}</dd>
    <dt>Écart (valeur − limite)</dt><dd>{format(delta)}</dd>
  </dl>
}
